import LegalLayout from "@/pages/LegalLayout";

const SECTIONS = [
  {
    heading: "Introduction",
    paragraphs: [
      "PeachFlow AI (\"PeachFlow\", \"we\", \"us\", or \"our\") builds custom AI agents for small businesses. This Privacy Policy explains how we collect, use, and protect information when you visit our website or engage our services.",
    ],
  },
  {
    heading: "Information we collect",
    paragraphs: ["We collect information you provide directly and information collected automatically, including:"],
    list: [
      "Contact details you submit through our \"Book a Call\" form (name, email, company, message, and preferred date).",
      "Business information you share with us during a project so we can build and train your AI agents.",
      "Basic usage data such as pages visited and general analytics, used to improve our website.",
    ],
  },
  {
    heading: "How we use your information",
    paragraphs: ["We use the information we collect to:"],
    list: [
      "Respond to your enquiries and schedule calls or demos.",
      "Design, build, deploy, and maintain your AI solution.",
      "Improve our services, website, and customer experience.",
      "Send relevant updates about your project (you can opt out at any time).",
    ],
  },
  {
    heading: "How we share information",
    paragraphs: [
      "We do not sell your personal information. We only share data with trusted service providers (such as cloud hosting and AI platforms) as needed to deliver our services, and only to the extent necessary. These providers are bound by confidentiality and data-protection obligations.",
    ],
  },
  {
    heading: "Data security",
    paragraphs: [
      "We follow industry best practices to protect your information, including encryption in transit and least-privilege access. While no system is completely secure, we work hard to safeguard the data entrusted to us.",
    ],
  },
  {
    heading: "Data retention",
    paragraphs: [
      "We retain personal information only as long as necessary to provide our services, comply with legal obligations, resolve disputes, and enforce our agreements. You may request deletion of your information at any time.",
    ],
  },
  {
    heading: "Your rights",
    paragraphs: [
      "Depending on your location, you may have the right to access, correct, or delete your personal information, or to object to certain processing. To exercise these rights, contact us at hello@peachflowai.com.",
    ],
  },
  {
    heading: "Third-party links",
    paragraphs: [
      "Our website may link to third-party sites or tools. We are not responsible for the privacy practices of those services, and we encourage you to review their policies.",
    ],
  },
  {
    heading: "Changes to this policy",
    paragraphs: [
      "We may update this Privacy Policy from time to time. Material changes will be reflected by updating the \"Last updated\" date at the top of this page.",
    ],
  },
  {
    heading: "Contact us",
    paragraphs: [
      "If you have any questions about this Privacy Policy or how we handle your data, email us at hello@peachflowai.com.",
    ],
  },
];

export default function Privacy() {
  return (
    <LegalLayout
      testId="privacy-page"
      title="Privacy Policy"
      updated="July 2026"
      intro="Your privacy matters to us. This policy describes what information we collect and how we use it."
      sections={SECTIONS}
    />
  );
}
